import styled, { keyframes } from 'styled-components';

const typingBounce = keyframes`
  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
  40% { transform: scale(1); opacity: 1; }
`;

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
`;

export const ChatButton = styled.button`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f46800 0%, #ff8833 100%);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(244, 104, 0, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  svg {
    stroke: #ffffff;
    fill: none;
  }

  &:hover {
    transform: scale(1.06);
    box-shadow: 0 8px 24px rgba(244, 104, 0, 0.5);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:hover {
      transform: none;
    }
  }
`;

export const ChatWindow = styled.div`
  position: absolute;
  bottom: 70px;
  right: 0;
  width: 340px;
  height: 480px;
  background-color: white;
  border: 1px solid #e4e7e7;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(17, 18, 23, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const WindowHeader = styled.div`
  padding: 16px 20px;
  background: #111217;

  p {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
  }

  span {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
  }
`;

export const MessageList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

export const MessageItem = styled.div<{ role: 'user' | 'assistant' }>`
  margin: 10px 0;
  padding: 10px;
  border-radius: 10px;
  max-width: 80%;
  word-wrap: break-word;
  overflow-wrap: anywhere;

  ${({ role }) => role === 'user' ? `
    background-color: #111217;
    color: white;
    margin-left: auto;
  ` : `
    background-color: #f4f5f5;
    color: #111217;
    margin-right: auto;
  `}

  /* Tame react-markdown output inside the narrow chat bubble */
  p {
    margin: 0 0 8px;
  }
  & > :last-child {
    margin-bottom: 0;
  }
  ul, ol {
    margin: 4px 0;
    padding-left: 20px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-word;
    background: rgba(0, 0, 0, 0.06);
    padding: 8px;
    border-radius: 6px;
    overflow-x: auto;
  }
  code {
    word-break: break-word;
  }
  a {
    color: inherit;
    text-decoration: underline;
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;

export const StatusLabel = styled.div`
  font-style: italic;
  color: #666;
  font-size: 0.85em;
  margin-bottom: 6px;
`;

export const TypingIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #888;
    display: inline-block;
    animation: ${typingBounce} 1.4s infinite ease-in-out both;
  }

  span:nth-child(1) { animation-delay: -0.32s; }
  span:nth-child(2) { animation-delay: -0.16s; }
`;

export const InputContainer = styled.div`
  padding: 15px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 10px;

  input {
    flex: 1;
    padding: 10px 14px;
    border: 1px solid #e4e7e7;
    border-radius: 999px;
    font-family: inherit;
    font-size: 14px;
    outline: none;

    &:focus {
      border-color: #f46800;
    }
  }
`;

export const SendButton = styled.button`
  padding: 10px 18px;
  background: linear-gradient(93deg, #f46800 0%, #ff8833 100%);
  color: #111217;
  font-weight: 700;
  font-family: inherit;
  font-size: 14px;
  border: none;
  border-radius: 999px;
  cursor: pointer;

  &:hover {
    filter: brightness(1.06);
  }

  &:disabled {
    background: #e4e7e7;
    color: #9da2a8;
    cursor: not-allowed;
    filter: none;
  }
`;
